/**
 * App Config File
 */
export default {
	appLogo: '/static/img/logo.png',                                   // App Logo,
	darkLogo: '/static/img/logo.png',							    // dark logo
	appLogo2: '/static/img/logo.png',                                    // App Logo 2 For Login & Signup Page
	brand: 'Salonworld',                                        			        // Brand Name
	copyrightText: 'Salonworld © 2009-2019 All Rights Reserved.',                     // Copyright Text
	enableUserTour: process.env.NODE_ENV === 'production' ? true : false   // Enable User Tour
}
